import React, { useState, useEffect, useContext } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { useStyles } from "./css";
import { LayoutContext } from "../../contexts/LayoutContext";

const loadingMessages = [
  "⚡ We are Spiking. Please wait.",
  "⚡ Spiking real-time Wall Street signals…",
  "⚡ SpikingAI® calibrating market intelligence…",
  "⚡ Your Spiking edge is loading…",
];

const MOBILE_BREAKPOINT = 1280;
const EXPANDED_DRAWER_WIDTH = 280;
const COLLAPSED_DRAWER_WIDTH = 48;

const Loader = (props) => {
  const { isLoading, drawerOpen } = props;
  const { hasLayout } = useContext(LayoutContext);
  const isMobile = window.innerWidth < MOBILE_BREAKPOINT;
  const drawerOffset = isMobile || !hasLayout ? 0 : drawerOpen ? EXPANDED_DRAWER_WIDTH : COLLAPSED_DRAWER_WIDTH;
  const classes = useStyles();
  const [seconds, setSeconds] = useState(0);
  const [message, setMessage] = useState(loadingMessages[0]);

  useEffect(() => {
    let interval = null;
    if (isLoading) {
      setSeconds(0);
      setMessage(loadingMessages[Math.floor(Math.random() * loadingMessages.length)]);
      interval = setInterval(() => {
        setSeconds((prev) => prev + 1);
      }, 1000);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isLoading]);

  if (!isLoading) return null;

  return (
    <div className={classes.dialogueRoot} style={{ left: drawerOffset }}>
      <div className={classes.loaderRoot}>
        <div className={classes.loaderWrapper}>
          <div className={classes.loader} />
          <div className={classes.loaderCounter}>{seconds}s</div>
        </div>
        <div className={classes.loadingText}>{message}</div>
      </div>
    </div>
  );
};

Loader.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  drawerOpen: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    isLoading:
      state.common.loading || state.options.initialTableLoadingCount > 0,
    drawerOpen: state.common.drawerOpen,
  };
};

export default connect(mapStateToProps)(Loader);
